import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// Styles
import { useTheme } from "@mui/material/styles";
import useStyles from "assets/jss/material-react/views/italmundoStyles";
// Components
import { Box, useMediaQuery, Button } from "@mui/material";
// Assets
import CheckModalIcon from "assets/img/CheckModalIcon.png";
import ItalmundoPreAprob from "assets/img/ItalmundoPreAprob.jpg";
import ItalmundoPreAprobMobile from "assets/img/ItalmundoPreAprobMobile.jpg";
import IconosPreAprob from "assets/img/IconosTarjetaPreAprob.png";
import PageContainer from "../../components/PageContainer/PageContainer";
import { getSessionDocument } from "services/sessionStorageService";
import { URLs } from "utils/redirectStep";

function TarjetaPreAprobada() {
  const classes = useStyles();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));
  const currentPathSegment = window.location.pathname.split("/")[1];
  const navigate = useNavigate();
  const getText = () => {
    return (
      <span>
        {" "}
        En las próximas horas un asesor se va
        <br />a comunicar contigo.{" "}
      </span>
    );
  };

  useEffect(() => {
    const documento = getSessionDocument();
    if (!documento) {
      navigate(URLs.home);
    }
  }, []);

  return (
    <PageContainer canonicalUrl={"/" + currentPathSegment}>
      <>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "0.2rem",
            width: "90%",
          }}
        >
          <img
            src={CheckModalIcon}
            alt="Check"
            style={{
              maxWidth: "32px",
              maxHeight: "100%",
              objectFit: "contain",
              marginTop: mobile ? "0.8rem" : "0rem",
            }}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "0.2rem",
              width: "90%",
            }}
          >
            <p
              style={{
                marginTop: "0.9rem",
                marginRight: "0.2rem",
                marginBottom: "0.2rem",
                fontWeight: 600,
                color: "#04808F",
              }}
            >
              GENIAL
            </p>
          </Box>

          <p
            style={{
              textAlign: "center",
              marginTop: "1rem",
              fontSize: mobile ? "13px" : "15px",
              fontWeight: 500,
              maxWidth: "600px",
            }}
          >
            {getText()}
          </p>

          <img
            src={mobile ? ItalmundoPreAprobMobile : ItalmundoPreAprob}
            alt="Tarjeta"
            style={{
              maxWidth: mobile ? "100%" : "550px",
              objectFit: "contain",
              marginTop: "1rem",
            }}
          />

          <img
            src={IconosPreAprob}
            alt="Home Mobile"
            style={{
              maxWidth: "320px",
              width: "90%",
              maxHeight: "100%",
              objectFit: "contain",
              marginTop: "1rem",
            }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: mobile ? "90%" : "100%",
            alignItems: "center",
            marginTop: "10px",
          }}
        >
          <Button
            className={`${classes.btnFull} ${classes.btnAzul}`}
            variant="text"
            href="https://italmundo.com.uy/beneficios/"
            target="_blank"
            sx={{
              marginTop: "1rem",
              width: mobile ? "100%" : "310px",
            }}
          >
            {"VER PROMOCIONES"}
          </Button>
        </Box>
      </>
    </PageContainer>
  );
}

export default TarjetaPreAprobada;
